var $e5e6023659c13c1d$exports = {};
"use strict";
const $e5e6023659c13c1d$var$card = document.querySelector(".card");
const $e5e6023659c13c1d$var$card__form = document.querySelector(".card__form--container");
const $e5e6023659c13c1d$var$success__msg = document.querySelector(".card__completed");
const $e5e6023659c13c1d$var$card__name = $e5e6023659c13c1d$var$card.querySelector(".card__name");
const $e5e6023659c13c1d$var$card__number = $e5e6023659c13c1d$var$card.querySelector(".card__number");
const $e5e6023659c13c1d$var$card__exp = $e5e6023659c13c1d$var$card.querySelector(".card__exp");
const $e5e6023659c13c1d$var$month = $e5e6023659c13c1d$var$card__exp.querySelector(".card__exp--month");
const $e5e6023659c13c1d$var$year = $e5e6023659c13c1d$var$card__exp.querySelector(".card__exp--year");
const $e5e6023659c13c1d$var$cvv = $e5e6023659c13c1d$var$card.querySelector(".card__cvv");
const $e5e6023659c13c1d$var$numError = $e5e6023659c13c1d$var$card__form.querySelector(".number__error");
const $e5e6023659c13c1d$var$expError = $e5e6023659c13c1d$var$card__form.querySelector(".exp__error");
const $e5e6023659c13c1d$var$nameError = $e5e6023659c13c1d$var$card__form.querySelector(".name__error");
const $e5e6023659c13c1d$var$cvvError = $e5e6023659c13c1d$var$card__form.querySelector(".cvv__error");
const $e5e6023659c13c1d$var$completeBtn = document.querySelector(".card__completed--btn");
const $e5e6023659c13c1d$var$form__name = $e5e6023659c13c1d$var$card__form.querySelector(".form__name");
const $e5e6023659c13c1d$var$form__number = $e5e6023659c13c1d$var$card__form.querySelector(".form__number");
const $e5e6023659c13c1d$var$form__month = $e5e6023659c13c1d$var$card__form.querySelector(".form__month");
const $e5e6023659c13c1d$var$form__year = $e5e6023659c13c1d$var$card__form.querySelector(".form__year");
const $e5e6023659c13c1d$var$form__cvv = $e5e6023659c13c1d$var$card__form.querySelector(".form__cvv");
const $e5e6023659c13c1d$var$currentMonth = new Date().getMonth();
const $e5e6023659c13c1d$var$currentYear = new Date().getFullYear();
function $e5e6023659c13c1d$var$renderval(obj, e) {
    obj.insertAdjacentHTML("afterbegin", e);
}
function $e5e6023659c13c1d$var$cleanValues() {
    $e5e6023659c13c1d$var$card__name.textContent = "Jane Appleseed";
    $e5e6023659c13c1d$var$card__number.textContent = "0000 0000 0000 0000";
    $e5e6023659c13c1d$var$month.textContent = "00";
    $e5e6023659c13c1d$var$year.textContent = "00";
    $e5e6023659c13c1d$var$cvv.textContent = "000";
    $e5e6023659c13c1d$var$form__name.value = "";
    $e5e6023659c13c1d$var$form__number.value = "";
    $e5e6023659c13c1d$var$form__month.value = "";
    $e5e6023659c13c1d$var$form__year.value = "";
    $e5e6023659c13c1d$var$form__cvv.value = "";
}
$e5e6023659c13c1d$var$card__form.addEventListener("keyup", function(e) {
    try {
        if (e.target.classList.contains("form__name")) {
            $e5e6023659c13c1d$var$nameError.classList.add("hidden");
            $e5e6023659c13c1d$var$card__name.textContent = "";
            $e5e6023659c13c1d$var$renderval($e5e6023659c13c1d$var$card__name, e.target.value);
            return;
        }
        if (e.target.classList.contains("form__number")) {
            $e5e6023659c13c1d$var$card__number.textContent = "";
            function cardFormat(num) {
                return num.replace(/(.{4})/g, "$1 ");
            }
            $e5e6023659c13c1d$var$renderval($e5e6023659c13c1d$var$card__number, cardFormat(e.target.value));
            if (isNaN(e.target.value)) throw Error("numError");
            $e5e6023659c13c1d$var$numError.classList.add("hidden");
            return;
        }
        if (e.target.classList.contains("form__month")) {
            $e5e6023659c13c1d$var$month.textContent = "";
            if (parseInt(e.target.value) > 12 || parseInt(e.target.value) < 1) throw Error("monthError");
            $e5e6023659c13c1d$var$renderval($e5e6023659c13c1d$var$month, e.target.value);
            $e5e6023659c13c1d$var$expError.classList.add("hidden");
            return;
        }
        if (e.target.classList.contains("form__year")) {
            $e5e6023659c13c1d$var$year.textContent = "";
            console.log(e.target.value);
            if (parseInt(e.target.value) < 24) throw Error("yearError");
            $e5e6023659c13c1d$var$renderval($e5e6023659c13c1d$var$year, e.target.value);
            $e5e6023659c13c1d$var$expError.classList.add("hidden");
            return;
        }
        if (e.target.classList.contains("form__cvv")) {
            $e5e6023659c13c1d$var$cvv.textContent = "";
            $e5e6023659c13c1d$var$renderval($e5e6023659c13c1d$var$cvv, e.target.value);
            $e5e6023659c13c1d$var$cvvError.classList.add("hidden");
            return;
        }
    } catch (err) {
        console.log(err.message);
        if (err.message === "numError") {
            $e5e6023659c13c1d$var$numError.textContent = "Wrong format, numbers only";
            $e5e6023659c13c1d$var$numError.classList.remove("hidden");
            return;
        }
        if (err.message === "monthError") {
            $e5e6023659c13c1d$var$expError.textContent = "Wrong date";
            $e5e6023659c13c1d$var$expError.classList.remove("hidden");
            return;
        }
        if (err.message === "yearError") {
            $e5e6023659c13c1d$var$expError.textContent = "Wrong date";
            $e5e6023659c13c1d$var$expError.classList.remove("hidden");
            return;
        }
    }
});
$e5e6023659c13c1d$var$card__form.addEventListener("submit", function(e) {
    e.preventDefault();
    try {
        const dataArr = [
            ...new FormData($e5e6023659c13c1d$var$card__form)
        ];
        const data = Object.fromEntries(dataArr);
        if (data.name === "") throw Error("empty_name");
        if (data.cardNum.length < 16 || data.cardNum === "") throw Error("invalid_card");
        if (parseInt(data.month) < $e5e6023659c13c1d$var$currentMonth + 1) throw Error("invalid_exp");
        if (data.month === "" || data.year === "") throw Error("blank_exp");
        if (data.cvv === "") throw Error("blank_cvv");
        $e5e6023659c13c1d$var$card__form.classList.add("hidden");
        $e5e6023659c13c1d$var$success__msg.classList.remove("hidden");
    } catch (err) {
        if (err.message === "empty_name") {
            $e5e6023659c13c1d$var$nameError.textContent = "Can't be blank";
            $e5e6023659c13c1d$var$nameError.classList.remove("hidden");
            return;
        }
        if (err.message === "invalid_card") {
            $e5e6023659c13c1d$var$numError.textContent = "Invalid card number";
            $e5e6023659c13c1d$var$numError.classList.remove("hidden");
            return;
        }
        if (err.message === "invalid_exp") {
            $e5e6023659c13c1d$var$expError.textContent = "Invalid date";
            $e5e6023659c13c1d$var$expError.classList.remove("hidden");
            return;
        }
        if (err.message === "blank_exp") {
            $e5e6023659c13c1d$var$expError.textContent = "Can't be blank";
            $e5e6023659c13c1d$var$expError.classList.remove("hidden");
            return;
        }
        if (err.message === "blank_cvv") {
            $e5e6023659c13c1d$var$cvvError.textContent = "Can't be blank";
            $e5e6023659c13c1d$var$cvvError.classList.remove("hidden");
            return;
        }
    }
});
$e5e6023659c13c1d$var$completeBtn.addEventListener("click", function() {
    $e5e6023659c13c1d$var$cleanValues();
    $e5e6023659c13c1d$var$card__form.classList.remove("hidden");
    $e5e6023659c13c1d$var$success__msg.classList.add("hidden");
});


//# sourceMappingURL=index.faba67e7.js.map
